import styled from '@app/styled';
import { spacing } from '@app/theme';

export const NavigationItemList = styled.ul`
    list-style: none;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    grid-gap: ${spacing(1)};
    justify-content: flex-start;
    margin: 0;
    padding: 0;
`;

export const NavigationItemWrapper = styled.li`
    border: none;
    margin: 0;
    background: none;
    appearance: none;
`;
